// extracted by mini-css-extract-plugin
module.exports = {"band":"CtaBand_band__1cPsH","ovals":"CtaBand_ovals__3Agp1","heading":"CtaBand_heading__1DbER","text":"CtaBand_text__1QmiU","buttons":"CtaBand_buttons__1l5wL"};